const sponsorConfig = {
  oldSponsorInfo: 'Use Last Year’s Ad Spot',
  infoFromPartner:
    'I will provide the information needed to create the ad spot.',
  infoFromSponsor:
    'Please contact my sponsor to get the information needed for creating the ad spot',
  choosePreviousSponsor:
    'You can either choose a previous sponsor from the list (or)',
  addNewSponsor: 'Click "Add New Sponsor" to add a new sponsor',
  existingSponsorDialogTitle:
    'Choose an existing Sponsor Commercial (or) Add New',
  overrideSponsorConfirmTask:
    'Are you sure you want to skip Sponsor Approval and send this script directly to the Message Creator',
};

export default sponsorConfig;

export const musicConfig = {
  reAddTrackSuccess:
    'Selected tracks have been re-added to the library. Tracks will be available in the player after the next sync',
  songSetDeleteWarning: (songSetName: string, hasMusicSchedule: boolean) =>
    `The following song set "${songSetName}" must be removed ${
      hasMusicSchedule
        ? 'from the following schedule(s)'
        : 'from the following event music mix(s) in Radio Mode'
    } before it can be deleted.`,
};

export const tnnSponsorConfig = {
  requestCompanySelection: 'Please select a company',
  noSchoolWarning: 'No school available for the selected company',
};

export const quickLaunchConfig = {
  addMessage: `Messaging is only available for Level 1 and Level 2 Partners. If you are interested in upgrading your account, please contact your Partner Success Manager, who can assist you.`,
};

export const alertMessageConfig = {
  fileNameWithoutZZZ: 'File name must not contain "zzz"',
  mp3_format_error: 'Please upload a valid mp3 file',
};

export const alertConfig = {
  mp3_format_error: 'Please upload a valid mp3 file',
};

export const confirmLockConfig = {
  confirmLockMessage:
    'This action will prevent any Player-side changes to this playlist from syncing to Voyager. Are you sure you want to continue?',
  confirmUnlockMessage:
    'This action will allow Player-side changes to this playlist to sync to Voyager. Are you sure you want to continue?',
  alertSuccessMessage:
    'Playlist locked successfully. Player-side changes will no longer sync to Voyager.',
  alertUnlockSuccessMessage:
    'Playlist unlocked successfully. Player-side changes will sync to Voyager',
};
export const tnnDemographicsConfig = {
  download_sample: 'Download Sample File',
  gt_download_pop_up:
    'GameTime Partners: (Person/Men/Women) per events are required to calculate Total (Person/Men/Women)',
  non_gt_download_pop_up:
    'Non-GameTime Partners: Total (Person/Men/Women) are required to calculate (Person/Men/Women) per events',
};
export const songRequestRejectedMessage =
  'This song is rejected. Please select a new one.';
